import { Grid, IconButton, InputBase, Paper, TextField } from "@mui/material";
import styles from "./Banner.module.css";
import SearchIcon from "@mui/icons-material/Search";

function Banner({ titulo, descricao, handle }) {
  return (
    <>
      <Grid className={styles.divBanner} container spacing={2}>
        <Grid size={{ xs: 1, md: 2 }}></Grid>
        <Grid size={{ xs: 10, md: 8 }}>
          <p className={styles.portalLabel}>{titulo}</p>
          <p className={styles.portalDescricao}>{descricao}</p>
        </Grid>
      </Grid>
    </>
  );
}

export default Banner;
